import { style, media } from "typestyle";
import { queries } from "styles/styles";

export const container = style(
  {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0 1.5rem",
    textAlign: "center",
  },
  media(queries.medium, {
    padding: "1.5rem 0",
    display: "flex",
    flexDirection: "row",

    $nest: {
      "div:nth-child(2)": {
        marginLeft: "1rem"
      }
    }
  })
);
